import { render, staticRenderFns } from "./update-password.vue?vue&type=template&id=218997b9&scoped=true&"
import script from "./update-password.vue?vue&type=script&lang=tsx&"
export * from "./update-password.vue?vue&type=script&lang=tsx&"
import style0 from "./update-password.vue?vue&type=style&index=0&id=218997b9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "218997b9",
  null
  
)

export default component.exports